
import axios from '../config/axios';

export const url = '/api/contact'


export const createcontact = ({
  token,
	telefono,
	empresa,
	nombre,
	correo,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && telefono && empresa && nombre && correo ) {

    axios.post(`${url}//create/basic/64afe75f8f58d74f340e807a`, {
		telefono,
		empresa,
		nombre,
		correo,

    }, {
      headers: {
        
        Authorization: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!telefono) {
		reject({
			status: 'error',
			info: 'telefono no esta definido',
		});
	}  else if (!empresa) {
		reject({
			status: 'error',
			info: 'empresa no esta definido',
		});
	}  else if (!nombre) {
		reject({
			status: 'error',
			info: 'nombre no esta definido',
		});
	}  else if (!correo) {
		reject({
			status: 'error',
			info: 'correo no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

